import useTranslation from 'next-translate/useTranslation';

import {
  CATERER_COMMUNITY_RESOURCES_PATH,
  CATERER_PORTAL_PATH,
  CATERING_GROWTH_PLATFORM_PATH,
  CATERING_HELP_CENTER_URL,
} from '@/paths';
import MenuAccordion from './MenuAccordion';
import MenuLink from './MenuLink';

type RestaurantMenuProps = {
  isAccordion?: boolean;
};

const RestaurantLinks: React.FC<unknown> = () => {
  const {t} = useTranslation('app-bar');

  return (
    <div className="flex flex-col gap-6 p-2">
      <MenuLink label={t('navLinks.signInToPartnerPortal')} path={CATERER_PORTAL_PATH} />
      <MenuLink label={t('navLinks.cateringGrowthPlatform')} path={CATERING_GROWTH_PLATFORM_PATH} />

      <MenuLink
        label={t('navLinks.restaurantPartnerCommunity')}
        path={CATERER_COMMUNITY_RESOURCES_PATH}
      />

      <MenuLink label={t('navLinks.helpCenter')} href={CATERING_HELP_CENTER_URL} />
    </div>
  );
};

const RestaurantMenu: React.FC<RestaurantMenuProps> = ({isAccordion = false}) => {
  const {t} = useTranslation('app-bar');

  if (!isAccordion) return <RestaurantLinks />;

  return (
    <MenuAccordion ariaLabel={t('navLinks.forRestaurants')} header={t('navLinks.forRestaurants')}>
      <RestaurantLinks />
    </MenuAccordion>
  );
};

export default RestaurantMenu;
